import { useLayoutEffect, useState } from 'react';

export default function Footer() {
  const [show, setShow] = useState(false);

  useLayoutEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 1000);
  }, []);

  if (!show) return <></>;
  return (
    <div className="text-center container">
      <p>Get in touch!</p>

      <p className="has-heading-3-font-size">
        Contact me at 096-226-2496 or via email at
      </p>
      <p className="has-heading-3-font-size">ffirst.wilasinee@gmail.com</p>
      <div className="app-footer__bottom"></div>
    </div>
  );
}
